import FinalPriveTypeFive from '../feature/Courses/FinalPriveTypeFive'

const FinalPriveTypeFivePage = () => {
  return (
    <FinalPriveTypeFive/>
  )
}

export default FinalPriveTypeFivePage